import React, { FunctionComponent } from 'react';

import {
  FlexibleWidthXYPlot,
  HorizontalGridLines,
  XAxis,
  YAxis,
  VerticalBarSeries,
  LabelSeries,
} from 'react-vis';

import { Timeslice } from 'scenes/Report/Report.helper';

import {
  maxScale,
  scalingData,
  tickScalingData,
} from '../PerformanceReports.helper';
import {
  Scale,
  reportColors,
  simpleLabelTransformer,
} from './YearOverYear.helper';

type Props = {
  totalsByYear: Scale[][];
  totalTransactions: Scale[];
  timeslice: Timeslice;
  tickFormat: (
    timeslice: Timeslice,
    scales?: Scale[],
  ) => (value: string, index: number) => JSX.Element;
  labelFormat: string;
  height: number;
};

const xOffset = 190;
const yOffset = -10;

const PlotByTotals: FunctionComponent<Props> = ({
  totalTransactions,
  totalsByYear,
  height,
  timeslice,
  labelFormat,
  tickFormat,
}) => {
  const maxY = maxScale(totalTransactions);
  const years = ['1', '2'];
  return (
    <FlexibleWidthXYPlot xType="ordinal" height={height}>
      <HorizontalGridLines />
      <XAxis tickFormat={tickFormat(timeslice, totalsByYear[0])} />
      {years.map((year, index) => (
        <VerticalBarSeries
          color={reportColors[index]}
          data={scalingData(totalsByYear[index], maxY)}
          cluster={year}
          key={year}
        />
      ))}
      {years.map((year, index) => (
        <LabelSeries
          key={year}
          labelAnchorX="middle"
          data={simpleLabelTransformer(
            maxY,
            index % 2 === 0 ? 75 - xOffset / totalsByYear.length : 20,
            yOffset,
            labelFormat,
            totalsByYear[index],
          )}
        />
      ))}
      <YAxis
        orientation="left"
        tickFormat={tickScalingData(totalTransactions, labelFormat)}
      />
    </FlexibleWidthXYPlot>
  );
};

export default PlotByTotals;
